export const JSON_URL = process.env.GATSBY_WORDPRESS_URL
